import { createQueryKeys } from '@lukemorales/query-key-factory';

import type {
  FetchMyInvoicesArgs,
  FetchMyInvoiceArgs,
  FetchMyChargesArgs,
  FetchHistoricalOrgInvoicesArgs,
  FetchHistoricalOrgInvoiceArgs,
  FetchHistoricalOrgPayoutStatementsArgs,
} from '../api/accountBilling.api';

import {
  fetchAccountBillingSummary,
  fetchMyInvoices,
  fetchMyInvoice,
  fetchMyCharges,
  fetchHistoricalOrgInvoices,
  fetchHistoricalOrgInvoice,
  fetchHistoricalOrgPayoutStatements,
} from '../api/accountBilling.api';

export const accountBillingQueryKeys = createQueryKeys('accountBilling', {
  fetchSummary: {
    queryFn: fetchAccountBillingSummary,
    queryKey: null,
  },
  fetchMyInvoices: ({ limit, offset }: FetchMyInvoicesArgs) => ({
    queryFn: () => fetchMyInvoices({ limit, offset }),
    queryKey: [limit, offset],
  }),
  fetchMyInvoice: ({ invoiceId }: FetchMyInvoiceArgs) => ({
    queryFn: () => fetchMyInvoice({ invoiceId }),
    queryKey: [invoiceId],
  }),
  fetchMyCharges: ({ limit, offset }: FetchMyChargesArgs) => ({
    queryFn: () => fetchMyCharges({ limit, offset }),
    queryKey: [limit, offset],
  }),
  fetchHistoricalOrgInvoices: ({
    organizationId,
    limit,
    offset,
  }: FetchHistoricalOrgInvoicesArgs) => ({
    queryFn: () =>
      fetchHistoricalOrgInvoices({ organizationId, limit, offset }),
    queryKey: [organizationId, limit, offset],
  }),
  fetchHistoricalOrgInvoice: ({
    organizationId,
    invoiceId,
  }: FetchHistoricalOrgInvoiceArgs) => ({
    queryFn: () => fetchHistoricalOrgInvoice({ organizationId, invoiceId }),
    queryKey: [organizationId, invoiceId],
  }),
  fetchHistoricalOrgPayoutStatements: ({
    organizationId,
    limit,
    offset,
  }: FetchHistoricalOrgPayoutStatementsArgs) => ({
    queryFn: () =>
      fetchHistoricalOrgPayoutStatements({ organizationId, limit, offset }),
    queryKey: [organizationId, limit, offset],
  }),
});
